<template>
    <div>
        <div v-if="loading"><div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
        <div class="payment-totals" v-if="!loading">
            <div class="row">
                <div class="col-8">Today's Payment</div>
                <div class="col-1">${{ formatCurrency( pricing.subtotal ) }}</div>
            </div>
            <div class="row" v-for="fee in pricing.fees" :class="{'subtotal': fee.isSubtotal, 'text-success': fee.value < 0}">
                <div class="col-8">{{ fee.label }}</div>
                <div class="col-1">${{ formatCurrency(fee.value) }}</div>
            </div>
            <div class="row total">
                <div class="col-8" >TOTAL</div>
                <div class="col-1">${{ formatCurrency(pricing.total) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['pricing', 'loading', 'rentnow'],

        methods: {
            formatCurrency(val) {
                return parseFloat(val).toFixed(2);
            },
        },
    }
</script>
